import { motion } from "framer-motion";

export default function ArticleCardSkeleton() {
  return (
    <motion.div
      className="group relative bg-card rounded-lg border border-border overflow-hidden hover:shadow-lg transition-all duration-300"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.3 }}
    >
      <div className="flex flex-col md:flex-row">
        {/* Image Skeleton */}
        <div className="md:w-1/3 h-48 md:h-auto relative overflow-hidden bg-muted animate-pulse">
          <div className="absolute inset-0 bg-gradient-to-r from-transparent via-white/10 to-transparent -translate-x-full animate-shimmer" />
        </div>

        {/* Content Skeleton */}
        <div className="flex-1 p-6 space-y-4">
          {/* Date Skeleton */}
          <div className="h-4 w-24 bg-muted rounded animate-pulse" />
          
          {/* Title Skeleton */}
          <div className="space-y-2">
            <div className="h-6 w-full bg-muted rounded animate-pulse" />
            <div className="h-6 w-3/4 bg-muted rounded animate-pulse" />
          </div>
          
          {/* Excerpt Skeleton */}
          <div className="space-y-2">
            <div className="h-4 w-full bg-muted rounded animate-pulse" />
            <div className="h-4 w-full bg-muted rounded animate-pulse" />
            <div className="h-4 w-2/3 bg-muted rounded animate-pulse" />
          </div>
          
          {/* Read More Skeleton */}
          <div className="h-4 w-20 bg-muted rounded animate-pulse" />
        </div>
      </div>
    </motion.div>
  );
}